var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('el-dialog', {
    attrs: {
      "title": "Email Detail",
      "close-on-click-modal": false,
      "visible": _vm.visible,
      "width": "1200px",
      "top": "3vh"
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.visible = $event;
      }
    }
  }, [_c('div', {
    staticClass: "pb20"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }],
    staticClass: "emailWrap"
  }, [_c('h3', {
    staticClass: "mt0 mb0 pb10 fs20 bottomLine"
  }, [_vm._v(_vm._s(_vm.detailInfo.emailSubject))]), _c('div', {
    staticClass: "snapshot"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.detailInfo.emailContent || '')
    }
  })])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }